import { gql } from '@apollo/client/core';

const IntrusionGatewayFieldsFragment = gql`
  fragment IntrusionGatewayFieldsFragment on qx_Gateway {
    id
    name
    connectionStatus
    syncStatus
    type
    place {
      id
      name
      hierarchy {
        name
      }
    }
  }
`;

export const IntrusionPanelDeviceFieldsFragment = gql`
  fragment IntrusionPanelDeviceFieldsFragment on qx_Device {
    id
    name
    connectionStatus
    gateway {
      ...IntrusionGatewayFieldsFragment
    }
  }
  ${IntrusionGatewayFieldsFragment}
`;

export const IntrusionPartitionStateFieldsFragment = gql`
  fragment IntrusionPartitionStateFieldsFragment on IntrusionPartition {
    id
    name
    index
    state
    stateValues
    alarm
    alarmValues
  }
`;

const IntrusionZoneStateFieldsFragment = gql`
  fragment IntrusionZoneStateFieldsFragment on IntrusionZone {
    id
    name
    index
    state
    stateValues
    alarm
    alarmValues
    canBypass
    type
    defaultVideoSourceID
    VideoSource {
      id
    }
  }
`;

const IntrusionZoneSummaryFieldsFragment = gql`
  fragment IntrusionZoneSummaryFieldsFragment on IntrusionZone {
    id
    name
    index
    stateValues
    alarmValues
  }
`;

export const IntrusionZoneAssignmentFragment = gql`
  fragment IntrusionZoneAssignmentFragment on PartitionZoneAssignments {
    enabled
    partitionID
    zoneID
    IntrusionZone {
      ...IntrusionZoneStateFieldsFragment
    }
  }
  ${IntrusionZoneStateFieldsFragment}
`;

export const IntrusionZoneAssignmentSummaryFragment = gql`
  fragment IntrusionZoneAssignmentSummaryFragment on PartitionZoneAssignments {
    zoneID
    IntrusionZone {
      ...IntrusionZoneSummaryFieldsFragment
    }
  }
  ${IntrusionZoneSummaryFieldsFragment}
`;
